<template>
  <div>
    <!-- <nav-head></nav-head> -->
    <div class="trainCalcDiv">
      <div class="paramMargin">
        <p>
          <span class="instanceName">{{ name }}</span>
          <span class="noNameInstance"
            >(iid{{ this.$route.params.instanceId }})</span
          >
          <a-button
            size="small"
            type="primary"
            style="margin-left: 1rem"
            @click="toHelpPage"
            v-if="hasHelp"
            >文档</a-button
          >
        </p>
        <!-- 算法名称、输入和输出 -->
        <p :v-if="inFieldNames.length">
          <b>输入字段：</b>
          <span>{{ inFieldNames.join("、") }}</span>
        </p>
        <p :v-if="outFieldNames.length">
          <b>输出字段：</b>
          <span>{{ outFieldNames.join("、") }}</span>
        </p>
      </div>
      <my-params
        :params="calcParams"
        buttonText="计算"
        inputType="table2d"
        v-if="paramsLoaded"
        @commit="doCalc"
        :buttonable="calcButtonAble"
      ></my-params>
      <my-result v-if="result" :result="result" :showAlert="true"></my-result>
    </div>
  </div>
</template>
<script>
import myParams from './params'
import myResult from './result'
import util from '../util'
export default {
  components: { myParams, myResult },
  data() {
    return {
      iid: '',
      name: '',
      calcParams: null,
      paramsLoaded: false,
      calcButtonAble: true,
      result: null,
      inFieldNames: [],
      outFieldNames: [],
      hasHelp: false
    }
  },
  methods: {
    async doCalc(event) {
      const resp = await this.$http.post(
        `/instance/${this.$route.params.instanceId}/calc`,
        event,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      this.result = resp.data
      this.calcButtonAble = true
    },
    toHelpPage() {
      util.toAlgHelp(this.aid, this.$router, true)
    }
  },
  async created() {
    if (!this.$route.params.instanceId) {
      this.$router.push('/instances')
      return ''
    }
    this.iid = this.$route.params.instanceId
    const resp = await this.$http.get(`/instance/${this.iid}/params`)
    this.calcParams = resp.data.params
    this.name = resp.data.name ? resp.data.name : '未命名实例'
    this.hasHelp = resp.data.has_help
    this.aid = resp.data.aid
    this.paramsLoaded = true
    // 输入数据列表
    for (const f of resp.data.input_field) {
      this.inFieldNames.push(f.name)
    }
    // 输出数据列表
    for (const f of resp.data.output_field) {
      this.outFieldNames.push(f.name)
    }
  }
}
</script>
